import { BOX_SHADOWS, COLORS } from 'constants/index';

const MuiCard = {
  root: {
    backgroundColor: COLORS.WHITE,
    borderRadius: '8px',
    width: '100%',
    boxShadow: BOX_SHADOWS.card,
  }
};

export default MuiCard;